import React, { useState } from "react";
import "./IntroBlog.css";
import Imagens from "../../../components/IMAGESCOMPONENT/ImageComponent";
import AbasBlog from "../parts/abasblog/AbasBlog";
import NavbarBlog from "../parts/navbarblog/Navbar";
import BlogDesc from "../parts/blogdesc/BlogDesc";
import FooterBlog from "../parts/footerblog/FooterBlog";
import IntroMenu from "./introMenu/IntroMenu";
import IntroDetails from "./introDetails/IntroDetails";
import IntroHome from "./introHome/IntroHome";
import Cortes from "./cortes/Cortes";

const receitas = [
  {
    titulo: "Cheesecake fria com Calda de Frutas Vermelhas",
    descricao:
      "Cheesecake suave, coberto com calda de frutas vermelhas, a sobremesa perfeita para adoçar momentos...",
    data: "16/12/2025",
    imagem: Imagens.Receita1,
  },
  {
    titulo: "Canapé de Choripán com Vinagrete de Manga e Castanha Picante",
    descricao:
      "Canapé de Choripán com Vinagrete de Manga e Castanha Picante, a combinação perfeita de...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
  {
    titulo: "Wok Asiático com Mignon Caramelizado e Stealth",
    descricao:
      "Texturas, contraste e aquele sabor agridoce que conquista logo na primeira garfada. Quer surpreender...",
    data: "15/12/2025",
    imagem: Imagens.Receita3,
  },
  {
    titulo: "Picanha na parrilla com purê de abóbora e batata rústica",
    descricao:
      "A idéia deste prato é deixar elegante, requintado e sofisticado. Uma apresentação bem gourmet.",
    data: "15/12/2025",
    imagem: Imagens.Receita4,
  },
  {
    titulo: "Ceviche de Camarão com Pistache",
    descricao:
      "Uma entrada leve, elegante e cheia de textura pra impressionar em qualquer ocasião. Já...",
    data: "15/12/2025",
    imagem: Imagens.Receita2,
  },
];

const IntroBlog = () => {
  const [abaAtiva, setAbaAtiva] = useState("HOME");
  const [detalhesGerais, setDetalhesGerais] = useState(false);

  const trocarAba = (aba) => {
    setAbaAtiva(aba);
    setDetalhesGerais(false); // reseta para o modo padrão
  };

  // Função dentro do componente
  const irParaAba = (aba) => {
  setAbaAtiva(aba); 
  setDetalhesGerais(false); 
  window.scrollTo({ top: 0, behavior: "smooth" }); 
};


  return (
    <>
      <NavbarBlog />

      <AbasBlog abaAtiva={abaAtiva} setAbaAtiva={irParaAba} />

      {/* MOSTRA DETALHES OU HOME COMPLETO */}
      {detalhesGerais ? (
  <IntroDetails />
) : abaAtiva === "HOME" ? (
  <IntroHome irParaAba={irParaAba} setDetalhesGerais={setDetalhesGerais} />
) : abaAtiva === "CORTES DE CARNE" ? (
  <Cortes />
) : (
  <IntroMenu
    titulo={abaAtiva}
    abrirDetalhes={() => {
      setDetalhesGerais(true);
      setAbaAtiva(abaAtiva); // mantém a aba selecionada
    }}
  />
)}


      <FooterBlog irParaAba={irParaAba} />

    </>
  );
};

export default IntroBlog;
